import {isNullOrUndefined} from "./is-null-or-undefined";

export function assertNotNullOrUndefined<T>(actual: T | null | undefined): asserts actual is T {
  if (isNullOrUndefined(actual)) {
    throw new Error(`${arguments[0]} is unexpectedly null or undefined`);
  }
}

export function assertNoError(error: Error | null | undefined): asserts error is null | undefined {
  if (!isNullOrUndefined(error)) {
    throw error;
  }
}
